import { Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AlertSwipeComponent } from './common-shared-modules/alert-swipe/alert-swipe.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //title = 'Group Renewal';
  @ViewChild(AlertSwipeComponent) private alertSwipe:
    AlertSwipeComponent;
  messageObj: any;
  showHeader: boolean = true;

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  private testBool: boolean;
  activatedRoute: any;

  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute,) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        console.log(this.previousUrl)
        console.log(this.currentUrl)
        this.testBool = this.currentUrl.includes('group-renewal-payment-processing');
        this.showHeader = !this.currentUrl.includes('payment-gateway');
        if (this.previousUrl == '/group-renewal-thank-you') {
          this.router.navigate(['group-renewal-thank-you']);
          this.messageObj = {
            "messageVal": "Please enter valid mobile number.",
            "classVal": "e",
            "showAlertSwipe": true
          }

          this.alertSwipe.sliderAlertSwipe(this.messageObj)
        }
      };
    });
  }
  /* dynamic page title start */
  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    )
      .subscribe(() => {

        var rt = this.getChild(this.route)
        rt.data.subscribe(data => {
          console.log(data);
          this.titleService.setTitle(data.title)
        })
      })
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }
  /* dynamic page title end */
}
